import React, { useState, useEffect } from 'react';
import ReactCrop from 'react-easy-crop';
import { isMobile } from 'react-device-detect';
import { Popover } from '@barges/react';
import classes from './classes.module.scss';
import getCroppedImage from './crop_image_util';
import withPGTranslation from '../../config/withPGTranslation';
import { log, LOG_LEVELS } from '../../../common/config/app_logger';
import Spiner from '../../../common/helpers/spiner';
import CustomSlider from '../../../common/helpers/custom_sliderder';
import { hideBodyScroll, unlockBodyScroll } from '../../../common/config/utils';

const { shared } = window;

function Cropper({
  file,
  onCropFinished,
  onCancel,
  visible,
  loading,
  t
}) {
  const [crop, onCropChange] = useState({ x: 0, y: 0 });
  const [zoom, onZoomChange] = React.useState(1);
  const [croppedArea, setCroppedArea] = useState(null);
  const [extracting, setExtracting] = useState(false);

  useEffect(() => {
    if (!visible) return undefined;

    hideBodyScroll();
    const handler = (e) => {
      // Define a margin for the edge (e.g., 10 pixels)
      const edgeMargin = 10;

      // Check if the touch event originated near the left or right edge
      if (e.pageX < edgeMargin || e.pageX > window.innerWidth - edgeMargin) {
        // Prevent the default browser action (swipe to navigate)
        e.preventDefault();
      }
    };

    document.addEventListener('touchstart', handler, { passive: false });

    return () => {
      document.removeEventListener('touchstart', handler);
      unlockBodyScroll();
    };
  }, [visible]);

  const onCropComplete = (area, croppedAreaPixels) => {
    log(LOG_LEVELS.DEBUG, 'Cropper', 'on crop complete');
    setCroppedArea(croppedAreaPixels);
  };

  const extractCropedImage = async () => {
    log(LOG_LEVELS.DEBUG, 'Cropper', 'extracting croped image');
    setExtracting(true);
    const croppedIMG = await getCroppedImage(file, croppedArea);
    setExtracting(false);
    onCropFinished(croppedIMG);
  };

  const renderLoading = () => {
    if (!loading && !extracting) return null;
    return <Spiner loaderColor={ shared.appColor } />;
  };

  const renderHeader = () => (
    <div className={ classes.header }>
      { t('settings.add_profile_image') }
    </div>
  );

  const renderSlider = () => (
    <div style={ { width: '50%' } }>
      <CustomSlider
        min={ 1 }
        max={ 3 }
        step={ 0.1 }
        value={ zoom }
        onUpdate={ onZoomChange }
      />
    </div>
  );

  const renderFooter = () => (
    <div className={ classes.footer }>
      { renderSlider() }
      <div>
        <button
          type="button"
          className={ classes.cancelButton }
          onClick={ onCancel }
        >
          { t('settings.cancel') }
        </button>
        <button
          type="button"
          className={ classes.confirmButton }
          onClick={ extractCropedImage }
        >
          { t('settings.save') }
        </button>
      </div>
    </div>
  );

  const renderCroper = () => (
    <ReactCrop
      image={ file }
      crop={ crop }
      zoom={ zoom }
      onCropChange={ onCropChange }
      onZoomChange={ onZoomChange }
      onCropComplete={ onCropComplete }
    />
  );

  const renderMobileCropperContent = () => (
    <div className={ classes.mobileContainer }>
      { renderHeader() }
      { renderLoading() }
      <div className={ classes.mobileCroperFrame }>
        { renderCroper() }
      </div>
      { renderFooter() }
    </div>
  );

  const renderCropperContent = () => (
    <div className={ classes.popupContainer }>
      { renderLoading() }
      { renderHeader() }
      <div className={ classes.cropperFrame }>
        { renderCroper() }
      </div>
      { renderFooter() }
    </div>
  );

  return (
    <Popover isOpen={ visible } centered contentClassName={ classes.cropperPopupContent }>
      {isMobile ? renderMobileCropperContent() : renderCropperContent()}
    </Popover>
  );
}

export default withPGTranslation(Cropper);
